import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import baseStyles from '../../ElementControlsStyles';
import InputWrapper from 'crazyEditor/components/EditorUI/BaseUI/InputWrapper/InputWrapper';
import { updateElementPosition } from 'crazyEditor/redux/modules/element/actions/elementLayoutActions';
import { getSelectedElementsWithDragPosition, getElementsForDesktopElementControlView, getParentLocationIfExists } from 'crazyEditor/redux/modules/element/elementSelectors';
import { isChildElement } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';

@connect(
  (state) => ({
    viewMode: state.editor.viewMode,
    selectedElements: getSelectedElementsWithDragPosition(state),
    parentLocation: getParentLocationIfExists(state)
  }),
  {updateElementPosition}
)
export default class PositionControl extends Component {
  constructor(props) {
    super(props);

    this.setXPosition = this.setXPosition.bind(this);
    this.setYPosition = this.setYPosition.bind(this);
  }

  setXPosition(event) {
    const { updateElementPosition, selectedElementIds, viewMode } = this.props;
    updateElementPosition(viewMode, selectedElementIds, parseInt(event.target.value, 10), null);
  }

  setYPosition(selectedElements, event) {
    const { updateElementPosition, selectedElementIds, viewMode, pageElement } = this.props;
    const value = parseInt(event.target.value, 10);
    if (value + selectedElements[0].layout.height < pageElement.layout.height) {
      updateElementPosition(viewMode, selectedElementIds, null, value);
    }
  }
  getFullWidthOrChildElementProps(isFullWidth = false, isChild = false) {
    return {
      readOnly: isFullWidth || isChild,
      disabled: isFullWidth || isChild
    };
  }

  render() {
    const { selectedElements, elementDefinitionProps, parentLocation } = this.props;

    const isChildElementSelected = isChildElement(selectedElements[0]);
    return (
      <div style={baseStyles.menuContainer}>
        <div style={baseStyles.menuTitle}>Position</div>
        <div style={baseStyles.menuBody}>
          <div style={baseStyles.menuBodyRow}>
            <label style={baseStyles.menuBodyLabel}>X:</label>
            <InputWrapper style={baseStyles.menuBodyInput}
                          inputStyle={baseStyles.menuBodyInputLabel}
                          type="number"
                          value={parentLocation ? parentLocation.x : selectedElements[0].layout.x}
                         {...this.getFullWidthOrChildElementProps(elementDefinitionProps.fullWidth, isChildElementSelected)}
                          onChange={this.setXPosition}/>
          </div>
          <div style={baseStyles.menuBodyRow}>
            <label style={baseStyles.menuBodyLabel}>Y:</label>
            <InputWrapper style={baseStyles.menuBodyInput}
                          inputStyle={baseStyles.menuBodyInputLabel}
                          type="number"
                          value={parentLocation ? parentLocation.y : selectedElements[0].layout.y}
                          disabled={isChildElementSelected}
                          onChange={this.setYPosition.bind(this, selectedElements)}/>
          </div>
        </div>
      </div>
    );
  }
}

PositionControl.propTypes = {
  selectedElementIds: PropTypes.array.isRequired,
  elementDefinitionProps: PropTypes.object.isRequired,
  pageElement: PropTypes.object.isRequired
};